import { lazy } from 'react';

export const NewOpenCase = lazy(() => import('./NewOpenCase'));
